/**
 * Columnas que el sitio público realmente consume del inventario (listado,
 * tarjetas, filtros, búsqueda del home, formularios y secciones del builder).
 *
 * Antes se pedían 60 columnas y 10 relaciones con `(*)`: para una automotora
 * de 500 autos eran ~900 KB en el cable (2,4 MB decodificados) en CADA página,
 * y buena parte era `gallery`, datos administrativos (vencimientos de permisos,
 * mantenciones, llaves…) y la fila completa de la sucursal repetida por auto.
 * Nada de eso lo lee ninguna superficie del sitio: la ficha trae su vehículo
 * completo por `getVehicleById` (lib/vehicles.ts) y no pasa por acá.
 *
 * Se conserva todo lo que sí se lee en alguna parte, aunque sea en una sola:
 * `description` (búsqueda de texto del home), `features` (tarjetas),
 * `seller_id` (formulario de financiamiento), `iva_exento`/`is_consigned`
 * (filtro Facturable), `traction`/`version_name` (filtros y título).
 *
 * `status` va con la FK explícita: vehicles apunta dos veces a
 * clients_vehicles_states (status_id y post_sale_status_id) y sin desambiguar
 * PostgREST responde 300 PGRST201.
 *
 * `vehicles_sales`/`vehicles_reservations`: solo lo que mira
 * `utils/webVisibility` (`created_at`, y el marcador histórico en ventas; las
 * reservas no tienen esa columna). Con la clave anónima hoy llegan vacías
 * igual (RLS), pero se piden para que la regla siga valiendo si algún día se
 * abren.
 *
 * Vive en un módulo sin dependencias para que lo compartan el store (que lo
 * ⚠️ `web_priority` tiene que estar: es la PRIMERA clave del orden inicial
 * (ticket #164) y sin ella el comparador del cliente ordenaría todo como Normal
 * y reordenaría al hidratar lo que la base ya había ordenado bien.
 *
 * pasa a supabase-js) y el arranque temprano del layout (que arma la URL REST
 * a mano): las dos consultas tienen que ser byte a byte la misma.
 */
export const VEHICLE_INVENTORY_SELECT = `
  id,created_at,client_id,year,price,discount_percentage,mileage,main_image,features,transmission,description,web_priority,
  brand_id,model_id,dealership_id,fuel_type_id,category_id,color_id,condition_id,status_id,
  is_consigned,seller_id,state_updated_at,label,traction,version_name,label_color,iva_exento,is_historical_import,
  brand:brand_id(id,name),
  model:model_id(id,name),
  category:category_id(id,name),
  fuel_type:fuel_type_id(id,name),
  condition:condition_id(id,name),
  status:clients_vehicles_states!vehicles_status_id_fkey(id,name,show_in_web,web_visibility_days),
  color:color_id(id,name),
  dealership:dealership_id(id,name,address),
  vehicles_sales!vehicle_id(created_at,is_historical_import),
  vehicles_reservations!vehicle_id(created_at)
`;
